module.exports = __webpack_public_path__ + "media/images/logo_note-d3f6a8451794adbbb4fe9dbfd6096ca7.png";